import React from 'react';
import { showNotification } from 'react-admin';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { exerciseToggleEnableGlobalwise } from './exerciseActions';

class ToggleApproveButton extends React.Component {
  state = {
    loading: false,
  };

  handleClick = () => {
    const { record, toggleEnable } = this.props;
    toggleEnable(record.id, record);
  };

  render() {
    const { record } = this.props;
    const { loading } = this.state;
    return (
      <Button variant="flat" color="primary" onClick={this.handleClick} disabled={loading}>
        {record.globalwise_approved ? 'Disable globalwise' : 'Enable globalwise'}
      </Button>
    );
  }
}

export default connect(
  null,
  {
    showNotification,
    toggleEnable: exerciseToggleEnableGlobalwise,
  },
)(ToggleApproveButton);



// WEBPACK FOOTER //
// ./src/resources/exercises/ToggleEnableGlobalwiseButton.jsx